import TextField from '@maison/components/form/fields/TextField.vue';
import FormGroup from '@maison/components/form/FormGroup.vue';
import modalMixin from '@phoenix/mixins/modalMixin';
import { defineAsyncComponent } from 'vue';
import { mapState } from 'vuex';

export default {
  components: {
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
    TextField,
    FormGroup,
  },

  mixins: [modalMixin],

  props: {
    productTracking: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fields: {
        reference: {
          id: 'reference',
          name: 'reference',
          value: '',
        },
        email: {
          id: 'email',
          name: 'email',
          label: this.$t('Form.email'),
          value: null,
          required: true,
        },
      },
      isShown: false,
    };
  },

  computed: {
    ...mapState('currentUser', ['customerInfo']),

    action() {
      return window.route('api.form.stock.subscribe');
    },

    descriptionText() {
      return this.$t('Product.stock.modalDescription', {
        reference: this.fields.reference.value,
      });
    },

    modalOptions() {
      return {
        onShow: (event) => {
          const props = this.getModalProps(event);
          this.initFields(props);
          this.isShown = true;
        },
      };
    },
  },

  methods: {
    initFields(props) {
      if (props.reference) {
        this.fields.reference.value = props.reference;
      } else {
        this.fields.reference.value = document
          .querySelector('.btn-stock-notification')
          .getAttribute('data-product-reference');
      }
      this.fields.email.value = this.customerInfo?.email || '';
    },

    async onSuccess() {
      this.addTracking();
      this.close();
    },

    addTracking() {
      window.tracking.pushEvent(window.tracking.getBackInStockTracking());
    },
  },
};
